










 

 











const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InvitationLinkDialog_massInvitation",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InvitationLinkErrorExpired_massInvitation"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "errorType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "inviterName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "teamName",
      "storageKey": null
    }
  ],
  "type": "MassInvitationPayload",
  "abstractKey": null
};

(node ).hash = "b0e2999a0f12ff2b793187cbcb22ea25";

export default node;
